import React, { useEffect, useState, useMemo } from "react";
import { useThemesContext } from "../../../../context/ThemeProvider";
import { Popper, TextField, Autocomplete } from '@mui/material';

import "./color-picker.scss"

const KeyboardArrowDownIcon = () => null;

const SettingsSelectLink = ({ id, label, initialValue, onChange }) => {
  const { pages } = useThemesContext();

  const [page, setPage] = useState(null);

  const options = useMemo(
    () =>
      pages
        ? pages.map(({ name, slug }) => ({ title: name, value: slug }))
        : [],
    [pages],
  );

  const handleChange = (_, newValue) => {
    setPage(newValue);
    onChange(id, newValue?.value ?? '');
  };

  useEffect(() => {
    if (pages.length && initialValue) {
      const { name, slug } = pages.find(page => page.slug === initialValue);
      setPage({ title: name, value: slug });
    } else {
      setPage(null);
    }
  }, [initialValue]);

  return (
    <div className="mb-4">
      <div className="paylixecommerce-label">
        {label}
      </div>

      <Autocomplete
          className="builder-autocomplete"
        fullWidth
        options={options}
        popupIcon={<KeyboardArrowDownIcon />}
        PopperComponent={Popper}
        selectOnFocus={false}
        getOptionLabel={option => option?.title}
        isOptionEqualToValue={(option, newValue) =>
          option?.title === newValue?.title
        }
        value={page}
        onChange={handleChange}
        renderInput={params => (
          <TextField className="builder-text-field" placeholder="Select link" {...params} />
        )}
      />
    </div>
  );
};

export default SettingsSelectLink;
